module.exports = __webpack_public_path__ + "static/openlaw2-bd792358926e2079ce7f9ac6f38a2c02.svg";